export default function(state = null, action = {}) {

    switch (action.type) {

        case 'TOGGLE_INFO_WINDOW':
			return angular.copy(action.props);
        default:
            return state;
    }
}